import clsx from "clsx"

type HeadlineProps = {
    headline: string
    className?: string
    bold?: boolean
    size?: 'small' | 'medium' | 'large' | 'xlarge'
    monster?: boolean
}
const Headline = ({ headline, className, bold = false, size = 'medium', monster = false }: HeadlineProps) => {
    return (
        <h2 className={clsx(className, 'text-blue', bold && 'font-bold', size === 'xlarge' && 'text-3xl lg:text-5xl leading-tight', size === 'large' && 'text-3xl lg:text-4xl leading-tight', size === 'medium' && 'text-2xl lg:text-3xl leading-tight', size === 'small' && 'text-xl lg:text-2xl leading-tight', monster && 'text-5xl lg:text-7xl leading-tight')} dangerouslySetInnerHTML={{ __html: headline }}>
        </h2>
    )
}

export default Headline